<template>
<div @load="loadImage">
    <div class="gameplay_title_container" >
      <div class="gameplay_title">
        {{ getTranslations.memory_list_game_title }}
      </div>
    </div>
    <img src="static/images/games/letter_white.svg" class="gameplay_list_image">
    <div class="gameplay_game_box_list">
      <div class="list_title">{{ gameInfo.listTitle }}</div>
      <div class="gameplay_divider"></div>
    <div class="gameplay_list_items gameplay_tap_row">
      <div v-for="col in numOfCols" :key="col" class="gameplay_list_col">
        <p v-for="(phase, index) in getListItems(col - 1)" :key="index" :ref="index + 1" >
          {{ phase }}
        </p>
      </div>
    </div>
    <button type="" @click="changeBrainiacMiniGameType()" class="gameplay_list_button">OK</button>

    </div>
</div>

</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapMutations, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';

export default {
  name: 'memoryList',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null,
    };
  },
  created() {
    console.log('in Game created hook');
    this.initGameData();
  },
  mounted() {
    this.$nextTick(() => { this.loadImage(); });
  },
  updated() {
    this.loadImage();
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
  },
  methods: {
    ...mapMutations('game', [
      'resetGameState',
    ]),
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      console.log(this.gameInfo);
      this.numOfRow = this.gameInfo.listItems.length === 8 ? 4 : 5;
      this.numOfCols = this.gameInfo.listItems.length === 8 ? 2 : 1;
    },
    getListItems(col) {
      if (this.numOfCols === 2 && col === 0) {
        console.log(col);
        return this.gameInfo.listItems.slice(0, this.gameInfo.listItems.length / 2);
      } else if (this.numOfCols === 2 && col === 1) {
        console.log(col);
        return this.gameInfo.listItems.slice(this.gameInfo.listItems.length / 2, this.gameInfo.listItems.length);
      }
      return this.gameInfo.listItems.slice(0, this.gameInfo.listItems.length);
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/game/memory/MemoryList.vue